import { httpClient } from '@/services/http/httpClient'

type DeleteAttachmentIdeaStepParams = {
  attachmentId: string
}

export const deleteAttachmentIdeaStep = async ({
  attachmentId,
}: DeleteAttachmentIdeaStepParams) => {
  await httpClient.delete(`/ideas/funnel/steps/attachment/${attachmentId}/`)
}
